<template>
  <section class="container">
    <div class="management_top_box">
      <h4>{{ $t("management.roleUserManagement") }}</h4>
    </div>
    <div class="brick_box">
      <table class="mgt_tbl mgb_0">
        <tbody>
          <tr>
            <th>
              {{ $t("management.roleId") }}
            </th>
            <td>
              {{ role.roleId }}
            </td>
            <th>{{ $t("management.roleName") }}</th>
            <td>
              {{ role.roleName }}
            </td>
            <th>{{ $t("common.description") }}</th>
            <td>{{ role.description }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="brick_box">
      <!--------------------------------  User 변경 저장 --------------------------------------------------------->
      <div class="p-2" style="text-align: right">
        <router-link to="/management/role" class="btn btn-outline-dark btn-md m-1">{{
          $t("common.list")
        }}</router-link>
        <button type="button" @click="addMember" class="btn btn-primary btn-md m-1">
          {{ $t("common.add") }}
        </button>
        <button type="button" @click="saveUserRole" class="btn btn-primary btn-md m-1">
          {{ $t("common.save") }}
        </button>
        <button
          type="button"
          @click="deleteUserRole"
          class="btn btn-secondary btn-md m-1"
        >
          {{ $t("common.delete") }}
        </button>
      </div>

      <!-----------------------------------  User  -------------------------------------------------->
      <div>
        <table class="list_tbl" style="text-align: left">
          <thead>
            <tr>
              <th class="mobile_h">
                <input
                  type="checkbox"
                  @click="goCheckAll($event.target.checked)"
                  v-model="checkAll"
                />
              </th>
              <th class="mobile_row">{{ $t("management.id") }}</th>
              <th class="mobile_row">{{ $t("common.name") }}</th>
            </tr>
          </thead>
          <tbody v-if="userList != null">
            <tr v-for="(user, index) in userList" :key="index">
              <td>
                <input type="checkbox" v-model="user.selected" />
              </td>
              <td :id="user.loginId">{{ user.loginId }}</td>
              <td>{{ user.userName }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="5">{{ $t("common.noData") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!---------------------------------User 추가------------------------------------------->
    <CommonModal id="memModal" v-if="showModal" @close="showModal == false">
      <template slot="header">
        <h3>{{ $t("management.addUser") }}</h3>
      </template>
      <template slot="body">
        <div class="list_top_box">
          <div class="float-end">
            <div class="list_top_search d-flex">
              <select
                class="int_type01"
                v-model="form.searchType"
                aria-label="sort select"
              >
                <option value="">--{{ $t("common.all") }}--</option>
                <option value="loginId">{{ $t("management.id") }}</option>
                <option value="userName">{{ $t("common.name") }}</option>
              </select>
              <input
                type="text"
                v-model="form.searchWord"
                name="userName"
                class="m-1 form-control"
              />
              <button type="button" @click="searchBtn" class="btn btn-primary btn-lg">
                {{ $t("common.search") }}
              </button>
            </div>
          </div>
        </div>
        <table class="list_tbl inner_tb">
          <thead>
            <tr>
              <th>
                <input
                  type="checkbox"
                  @click="goCheckModalAll($event.target.checked)"
                  class="form-check-input"
                  v-model="checkAll"
                />
              </th>
              <th class="mobile_h">{{ $t("management.id") }}</th>
              <th class="mobile_h">{{ $t("signup.name") }}</th>
              <th class="mobile_h">{{ $t("signup.email") }}</th>
            </tr>
          </thead>
          <tbody v-if="mgmtUser.length != 0">
            <tr v-for="(item, index) in mgmtUser" :key="index">
              <td>
                <input type="checkbox" v-model="item.selected" class="form-check-input" />
              </td>
              <td>{{ item.loginId }}</td>
              <td>{{ item.userName }}</td>
              <td>{{ item.emailAddress }}</td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="4">{{ $t("common.noData") }}</td>
            </tr>
          </tbody>
        </table>
        <div v-if="mgmtUser.length != 0" class="paging_nav">
          <div class="paging_nav">
            <a
              href="javascript:void(0)"
              v-if="pagingVO.startPage <= pagingVO.blockSize"
              class="page_select prev_page disabled"
              >이전페이지 이동</a
            >
            <a
              v-else
              class="page_select prev_page"
              @click="searchPage(pagingVO.startPage - pagingVO.blockSize)"
              v-bind:data-page="pagingVO.startPage - pagingVO.blockSize"
              >이전페이지 이동</a
            >
            <span
              v-for="(pages, index) in pagingVO.endPage - pagingVO.startPage + 1"
              :key="index"
            >
              <strong v-if="pagingVO.startPage + index == pagingVO.currentPage">{{
                pagingVO.startPage + index
              }}</strong>
              <a
                href="javascript:void(0)"
                v-else
                @click="searchPage(pagingVO.startPage + index)"
                >{{ pagingVO.startPage + index }}</a
              >
            </span>
            <a
              v-if="pagingVO.endPage >= pagingVO.totalPage"
              href="javascript:void(0)"
              class="page_select next_page disabled"
              >다음페이지 이동</a
            >
            <a
              v-else
              href="javascript:void(0)"
              @click="searchPage(pagingVO.endPage + 1)"
              v-bind:data-page="pagingVO.endPage + 1"
              class="page_select next_page"
              >다음페이지 이동</a
            >
          </div>
        </div>
      </template>
      <template slot="footer">
        <button type="button" @click="getSelected" class="btn btn-primary">
          {{ $t("common.choose") }}
        </button>
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </CommonModal>
  </section>
</template>

<script>
import { getAllUserList } from "@/api/user";
import { getRole, getRoleUser, saveUserRole, deleteUserRole } from "@/api/role"; //, deleteRoleUser, saveRoleUser
import CommonModal from "@/components/modal/CommonModal";
export default {
  components: {
    CommonModal,
  },
  data() {
    return {
      role: "",
      loginId: "",
      roleId: "",
      mgmtUser: "",
      roleList: [],
      userList: [],
      form: {
        searchType: "",
        searchWord: "",
        page: 1,
      },
      pagingVO: "",
      confirmYN: false,
      checkAll: false,
      deleteList: [],
      showModal: false,
    };
  },
  methods: {
    async fetchData() {
      try {
        this.roleId = this.$route.params.roleId;
        const { data } = await getRole(this.roleId);
        // 사용자 정보
        this.role = data.role;
        const response = await getRoleUser(this.roleId);
        this.userList = response.data.userList;
      } catch (error) {
        console.log(error);
      }
    },
    closeModal() {
      this.showModal = false;
    },
    // user 검색
    searchBtn() {
      this.form.page = 1;
      this.addMember();
    },
    // 페이지 클릭 시
    searchPage(page) {
      this.form.page = page;
      this.addMember();
    },
    // 관리자 검색 모달 show
    async addMember() {
      try {
        const { data } = await getAllUserList(this.form);
        this.mgmtUser = data.pagingVO.dataList;
        this.pagingVO = data.pagingVO;
        this.showModal = true;
        // $("#memModal").modal("show");
        // this.isModalViewed =true;
      } catch (err) {
        console.log(err);
      }
    },
    // 체크 박스 선택 시 중복 확인
    checkDuplicate() {
      console.log("chk");
      for (let i in this.userList) {
        for (let j in this.mgmtUser) {
          if (this.mgmtUser[j].selected) {
            if (this.userList[i].loginId == this.mgmtUser[j].loginId) {
              return true;
            }
          }
        }
      }
      return false;
    },
    //선택한 메뉴 기존 리스트에 추가
    getSelected() {
      if (!this.checkDuplicate()) {
        for (let i in this.mgmtUser) {
          if (this.mgmtUser[i].selected) {
            this.mgmtUser[i].crudType = "I";
            this.mgmtUser[i].roleId = this.roleId;
            this.userList.push(this.mgmtUser[i]);
          }
          this.mgmtUser[i].selected = false;
        }
        this.showModal = false;
      } else {
        alert(this.$t("alert.aUserAlreadyAddedExists"));
      }
    },
    //체크한 user 삭제
    async deleteUserRole() {
      for (let i in this.userList) {
        if (this.userList[i].selected) {
          this.deleteList.push(this.userList[i]);
        }
      }
      if (this.deleteList.length > 0) {
        this.confirmYN = confirm(this.$t("alert.delete"));
        if (this.confirmYN) {
          try {
            const { data } = await deleteUserRole(this.deleteList);
            if (data.status) {
              alert(this.$t("alert.deletedSuccessfully"));
              this.deleteList = [];
              this.fetchData();
            } else {
              alert(this.$t("alert.ErrorPlzcontactManager"));
            }
          } catch (error) {
            console.log(error);
          }
        } else {
          this.deleteList = [];
          return;
        }
      }
    },
    //User 변경 사항 저장
    async saveUserRole() {
      try {
        const { data } = await saveUserRole(this.userList);
        if (data.status) {
          alert(this.$t("alert.changedSuccessfully"));
        } else {
          alert(this.$t("alert.ErrorPlzcontactManager"));
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 전체선택
    goCheckAll(checked) {
      this.checkAll = checked;
      for (let i in this.userList) {
        this.userList[i].selected = this.checkAll;
      }
    },
    goCheckModalAll(checked) {
      // this.checkAll = checked;
      for (let i in this.mgmtUser) {
        this.mgmtUser[i].selected = checked;
      }
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style scoped></style>
